/* Stephens Publishing theme — one small script, no dependencies.
   Everything here is progressive enhancement: with JS off the site is fully
   visible and every form still posts. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1 · Fail-open scroll reveals (see base.css). */
  function armReveals(root) {
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { threshold: 0.15 }
    );
    (root || document).querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
      io.observe(el);
    });
    document.documentElement.classList.add('reveal-ready');
  }

  /* 2 · Mobile menu disclosure. */
  function initMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var panel = document.getElementById('mobile-menu');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.textContent = open ? btn.dataset.openLabel : btn.dataset.closeLabel;
      panel.hidden = open;
    });
  }

  /* 3 · Hero parallax — the image drifts 64px over the hero's scroll. */
  function initParallax() {
    var media = document.querySelector('[data-parallax]');
    if (!media || reduce) return;
    var hero = media.closest('.hero');
    var max = 64;
    var ticking = false;
    function update() {
      ticking = false;
      var h = hero.offsetHeight || 1;
      var p = Math.min(Math.max(window.scrollY / h, 0), 1);
      media.style.transform = 'translate3d(0,' + (p * max).toFixed(1) + 'px,0) scale(1.25)';
    }
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* 4 · Book page: format picker → variant id, price, button state. */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var button = root.querySelector('[data-buy]');
    var labels = button ? button.dataset : {};

    function current() {
      var picked = [];
      root.querySelectorAll('[data-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        picked.push(c ? c.value : null);
      });
      return variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return o === picked[i];
        });
      })[0];
    }

    function render() {
      var v = current();
      if (!v) {
        if (button) {
          button.disabled = true;
          button.querySelector('[data-buy-label]').textContent = labels.unavailable;
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare || '';
        compareEl.hidden = !v.compare;
      }
      if (button) {
        button.disabled = !v.available;
        button.querySelector('[data-buy-label]').textContent = v.available ? labels.buy : labels.soldout;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-option] input').forEach(function (input) {
      input.addEventListener('change', render);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    armReveals();
    initMenu();
    initParallax();
    initProduct();
  });

  /* Theme editor: newly added sections should show immediately. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  });
})();
